import React, { Component }         from 'react';

class ReadSign extends Component {
    constructor(props) {
        super(props);

        this.state = {
            read: false
        }
    }

    componentDidMount() {
        setTimeout(()=>{
            this.setState({read: true})
        }, 1000)
    }

    render(){
        var className = "message-read-sign" + (this.state.read ? ' read-sign' : ' not-read-sign');
        return (
            <div className={className} />
        );
    }
}

export default ReadSign;